import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    input,
    output,
    viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { injectViewportBreakpoints } from '@quipex/core/utils';
import { QpxButton, QpxIcon, QpxLogo } from '@quipex/shared/ui';

@Component({
    selector: 'qpx-header',
    imports: [MatButtonModule, NgIcon, QpxButton, QpxIcon, RouterLink, QpxLogo],
    templateUrl: './header.html',
    styleUrls: ['./header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
    //#region Dependency injection
    private readonly viewport = injectViewportBreakpoints();
    //#endregion

    //#region Inputs
    public readonly isExpanded = input(true);
    public readonly isVisuallyExpanded = input<boolean>();
    //#endregion

    //#region Outputs
    public readonly toggleRequested = output<void>();
    //#endregion

    //#region State
    protected readonly isRailOrWider = this.viewport.atLeast('tablet768');
    protected readonly visuallyExpanded = computed(
        () => this.isVisuallyExpanded() ?? this.isExpanded()
    );
    //#endregion

    //#region Template references
    private readonly navigationToggle = viewChild('navigationToggle', {
        read: ElementRef<HTMLButtonElement>,
    });
    //#endregion

    //#region Public methods
    public focusNavigationToggle(): void {
        this.navigationToggle()?.nativeElement.focus();
    }
    //#endregion

    //#region Template methods
    protected toggleNavigation(): void {
        this.toggleRequested.emit();
    }
    //#endregion
}
